import {Component, OnInit, ViewChild} from '@angular/core';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {CustomersApiService} from '../../services/api/customers/customers-api.service';
import {CustomersDialogComponent} from './customers-dialog/customers-dialog.component';
import * as _ from 'lodash';
import {CacProfilesApiService} from '../../services/api/routing/cac-profiles/cac-profiles-api.service';
import Search from '../../utils/search';
import {LogicalConjunctionService} from '../../services/common/logical-conjunction/logical-conjunction.service';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import {
  PrefixGroupsApiService
} from '../../services/api/settings/call-flow-configurations/prefix-groups/prefix-groups-api.service';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {PageEvent} from '@angular/material/paginator';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import {
  TableColumnsConfigurationDialogComponent
} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {CustomersSearchComponent} from './customers-search/customers-search.component';
import {CacStatePipe} from '../../pipes/cac-state/cac-state.pipe';
import {AdminStatePipe} from '../../pipes/admin-state/admin-state.pipe';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';

@Component({
  selector: 'customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {


  isUnauthorized: boolean;
  search: any = {};
  data = {elements: [], totalElements: 0};
  length: any;
  customersSearchComponent = CustomersSearchComponent;
  searchData;

  selection;
  isMultipleSelection = true;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  @ViewChild(ArmTableComponent) armTable;

  displayedColumns: Array<DisplayedColumnInf> = [
    { name: 'name', display: 'Name', selected: true , width: 200},
    { name: 'cacState', display: 'CAC State', selected: true, width: 200, transformer: CacStatePipe },
    { name: 'adminState', display: 'Admin State', selected: true , width: 200, transformer: AdminStatePipe},
    { name: 'attributeGroupsNames', display: 'Prefix Groups', selected: true, width: 200 },
    { name: 'tag', display: 'Policy Studio Tag', selected: true, width: 200 },
    { name: 'sipHeaderName', display: 'SIP Header Name', selected: true , width: 200},
    { name: 'sipHeaderValue', display: 'SIP Header Value', selected: true , width: 200},
    { name: 'cacProfileName', display: 'CAC Profile', selected: true , width: 200}
  ];

  prefixGroups = [];
  cacProfiles = [];

  cacProfileSearchOptions = [];
  prefixGroupsSearchOptions = [];

  searchTerms: SearchTermDefinitionInf[];

  constructor(private customersApiService: CustomersApiService,
              private snackBarService: SnackBarService,
              private userPrivilege: UserPrivilegeService,
              private logicalConjunctionService: LogicalConjunctionService,
              public dialog: MatDialog,
              private cacProfilesApiService: CacProfilesApiService,
              private prefixGroupsApiService: PrefixGroupsApiService,private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();

    this.refresh();
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  addItem(): void {
    const dialogRef = this.dialog.open(CustomersDialogComponent, {
      data: {
        isEditMode: false,
        selectedItem: {
          primary: true
        },
        cacProfiles: this.cacProfiles,
        prefixGroups: this.prefixGroups
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.customersApiService.addCustomer(result.selectedItem).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.selectedItem.name}" successfully added`);
        this.refresh();
      });
    });
  }

  editItem(): void {
    const dialogRef = this.dialog.open(CustomersDialogComponent, {
      data: {
        isEditMode: true,
        selectedItem: _.cloneDeep(this.selection[0]),
        cacProfiles: this.cacProfiles,
        prefixGroups: this.prefixGroups
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.customersApiService.editCustomer(result.selectedItem, result.selectedItem.id).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.selectedItem.name}" successfully edited`);
        this.refresh();
      });
    });
  }

  removeItem(): void {
    const ids = this.selection.map(connection => connection.id);

    const confirmationMessage = `Are you sure you want to delete ${ids.length === 1 ?
        `the customer: "${this.selection[0].name}"` :
        `${ids.length} customers: ${this.logicalConjunctionService
            .generateAndDescription(this.selection, 'name')}`} ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
        this.customersApiService.deleteCustomers(this.selection.map(selectionItem => selectionItem.id)).then((body) => {
          const names = [];
          body.multiStatusJsonList.forEach((customer) => {
            if (customer.status === 200) {
              const name = this.getCustomerNameById(customer.id);
              names.push({
                 name
              });
            }
            });
          dialogRef.close();
          this.refresh();
          if (names.length > 0) {
            this.snackBarService.display(`${this.logicalConjunctionService
              .generateAndDescription(names, 'name')} successfully deleted`);
          }

        });
    });
  }

  refresh(): void {
    const customersParams = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    Promise.all([
      this.cacProfilesApiService.getCacProfiles().toPromise(),
      this.prefixGroupsApiService.getPrefixGroupsSlim().toPromise(),
      this.customersApiService.getCustomers(customersParams).toPromise()
    ]).then((data) => {
      this.cacProfiles = data[0].elements;
      this.prefixGroups = data[1].elements.filter((prefixGroup) => prefixGroup.type === 'PREFIX');

      this.data = data[2];
      this.addAdditionalDataToCustomers();
      this.setSearchOptions();
      this.loaderService.hideMainContainer();
    }).catch((error) =>{
      this.loaderService.hideMainContainer();
    });
  }

  refreshItems(): void {
    const customersParams = {...this.search, ...this.serverPageRequest};

    this.customersApiService.getCustomers(customersParams).subscribe(data => {
      this.data = data;
      this.addAdditionalDataToCustomers();
    });
  }

  isMixedAdminState(): boolean {
    if (!this.isAnySelection()) { return; }

    const firstSelectedCustomer = this.selection[0];

    return this.selection.some(customer => firstSelectedCustomer.adminState !== customer.adminState);
  }

  lock(): void {
    this.customersApiService.lockCustomers(this.selection.map(selectionItem => selectionItem.id)).then(() => {
      this.refresh();
      this.snackBarService.display(`${this.logicalConjunctionService
          .generateAndDescription(this.selection, 'name')} successfully locked`);
    }).catch(() => {});
  }

  unlock(): void {
    this.customersApiService.unlockCustomers(this.selection.map(selectionItem => selectionItem.id)).then(() => {
      this.refresh();
      this.snackBarService.display(`${this.logicalConjunctionService
          .generateAndDescription(this.selection, 'name')} successfully unlocked`);
    }).catch(() => {});
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '350px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  onSearch(data): void {
    this.armTable.firstPage();
    this.serverPageRequest.firstPage();
    this.search = data;

    this.refreshItems();
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);

    this.refreshItems();
  }

  isSingleSelection(): boolean {
    return this.selection && this.selection.length === 1;
  }

  isAnySelection(): boolean {
    return  this.selection && this.selection.length > 0;
  }

  private setSearchOptions(): void {
    this.prefixGroupsSearchOptions = Search.generateSearchOptions(this.prefixGroups, 'name', 'id');
    this.cacProfileSearchOptions = Search.generateSearchOptions(this.cacProfiles, 'name', 'id');
    const cacStateSearchOptions = [
      { text: 'Active', value: 'UNBLOCK' },
      { text: 'Blocked', value: 'BLOCK' },
      { text: 'Blocked for Incoming', value: 'BLOCK_INCOMING' },
      { text: 'Blocked for Outgoing', value: 'BLOCK_OUTGOING' }
    ];

    const adminStateSearchOptions = [
      { text: 'Locked', value: 'LOCKED' },
      { text: 'Unlocked', value: 'UNLOCKED' }
    ];

    const sipHeaderNameSearchOptions = [
      { text: 'CONTACT_HOST', value: 'CONTACT_HOST' }
    ];



    this.searchData = {
      prefixGroupsSearchOptions: this.prefixGroupsSearchOptions,
      cacProfileSearchOptions: this.cacProfileSearchOptions,
      cacStateSearchOptions,
      adminStateSearchOptions,
      sipHeaderNameSearchOptions
    };

    this.searchTerms  = [
      { term: 'name', operator: ':', displayName: 'Name' },
      { term: 'operativeState', operator: '=', displayName: 'CAC State' ,displayValue: Search.getOptionValue(cacStateSearchOptions)},
      { term: 'adminState', operator: '=', displayName: 'Administrative State' ,displayValue: Search.getOptionValue(adminStateSearchOptions)},
      { term: 'attrGroupsIds', operator: '=', displayName: 'Prefix Group', displayValue: Search.getOptionValue(this.prefixGroupsSearchOptions)},
      { term: 'tag', operator: ':', displayName: 'Policy Studio Tag' },
      { term: 'sipHeaderName', operator: '=', displayName: 'SIP Header Name' , displayValue: Search.getOptionValue(sipHeaderNameSearchOptions)},
      { term: 'sipHeaderValue', operator: ':', displayName: 'SIP Header Value' },
      { term: 'cacProfileId', operator: '=', displayName: 'CAC Profile' , displayValue: Search.getOptionValue(this.cacProfileSearchOptions)},
    ];





  }

  private addAdditionalDataToCustomers(): void {
    this.data.elements.forEach(customer => {
      customer.attributeGroupsNames = customer.attributeGroups.map(attributeId => {
        const prefixGroup = this.prefixGroups.find(attributeGroup => attributeGroup.id === attributeId);
        return prefixGroup ? prefixGroup.name : null;
      });

      const cacProfile = this.cacProfiles.find(profile => profile.id === customer.cacProfileId);
      customer.cacProfileName = cacProfile ? cacProfile.name : null;
    });
  }

  private getCustomerNameById(id: any): any {
    for (const entry of this.data.elements) {
      if ( entry.id === id ) {
        return entry.name;
      }
    }
  }
}
